import answersImg from '@components/competitions/levels/tekyehmajazi/assets/images/t0/answers.webp';
import {questions} from '@components/competitions/levels/tekyehmajazi/assets/questions';
import MissionCompleted from '@components/competitions/levels/tekyehmajazi/MissionCompleted';
import Phone from '@components/competitions/levels/tekyehmajazi/Phone';
import {useCompetitionTekyehmajaziContext} from '@context/CompetitionTekyehmajaziContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography
} from '@mui/material';
import {useEffect, useState} from 'react';

interface SpecialComponentProps {
	allowedHours: number[];
	// minutes?: number[];
	allowedDays: number[];
}

const SpecialComponent = ({allowedHours, allowedDays}: SpecialComponentProps) => {
	const [expanded, setExpanded] = useState<string | false>(false);
	const [dialogShownFor, setDialogShownFor] = useState<Set<string>>(new Set());
	const [disabledState, setDisabledState] = useState({
		panel1: true,
		panel2: true,
		panel3: true
	});
	const [countdown, setCountdown] = useState<number | null>(null);
	const [selectedAnswers, setSelectedAnswers] = useState<{[key: string]: number | null}>({});
	const [selectedPanel, setSelectedPanel] = useState<string | null>(null);
	const [correctnessArray, setCorrectnessArray] = useState<number[]>([]);
	const [showSubmit, setShowSubmit] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const [currentMinutes, setCurrentMinutes] = useState(new Date().getMinutes());
	const {
		phone,
		setPhone,
		answers,
		setAnswers,
		correctAnswers,
		setCorrectAnswers,
		mission,
		setMission
	} = useCompetitionTekyehmajaziContext();
	// Get today's date
	const today = new Date().getDate();
	const todayQuestions = allowedDays.includes(today) ? questions[today] || [] : [];
	
	useEffect(() => {
		const storedData = localStorage.getItem('userAnswers');
		if (storedData) {
			const {day, answers} = JSON.parse(storedData);
			if (day === today) {
				setSelectedAnswers(answers);
			} else {
				localStorage.removeItem('userAnswers');
			}
		}
	}, []);
	
	const updateTimeState = () => {
		const now = new Date();
		const currentHours = now.getHours();
		const minutes = now.getMinutes();
		const seconds = now.getSeconds();
		
		setCurrentMinutes(minutes); // Store minutes in state
		
		let newDisabledState = {panel1: true, panel2: true, panel3: true};
		let newExpanded: string | false = false;
		let nextActiveTime: number | null = null;
		
		if (minutes >= 15 && minutes < 23) {
			newDisabledState.panel1 = false;
			newExpanded = 'panel1';
			nextActiveTime = ((23 - minutes) * 60) - seconds;
		} else if (minutes >= 25 && minutes < 33) {
			newDisabledState.panel2 = false;
			newExpanded = 'panel2';
			nextActiveTime = ((33 - minutes) * 60) - seconds;
		} else if (minutes >= 35 && minutes < 45) {
			newDisabledState.panel3 = false;
			newExpanded = 'panel3';
			nextActiveTime = ((45 - minutes) * 60) - seconds;
		} else {
			newExpanded = false;
			nextActiveTime = null;
		}
		
		setDisabledState(newDisabledState);
		setExpanded(newExpanded);
		setCountdown(nextActiveTime);
	};
	
	useEffect(() => {
		updateTimeState();
		const interval = setInterval(updateTimeState, 1000);
		return () => clearInterval(interval);
	}, [allowedHours]);
	
	useEffect(() => {
		const storedCompetitionDay = localStorage.getItem('competitionDay') ?? null;
		if (storedCompetitionDay) {
			const competitionDay = parseInt(storedCompetitionDay, 10);
			if (competitionDay === today) {
				setMission(2);
			}
		}
	}, [today]);
	
	useEffect(() => {
		if (countdown === null) return;
		const countdownInterval = setInterval(() => {
			setCountdown(prev => {
				if (prev === null || prev <= 0) {
					clearInterval(countdownInterval);
					return null;
				}
				return prev - 1;
			});
		}, 1000);
		
		return () => clearInterval(countdownInterval);
	}, [countdown]);
	
	const handleAnswerChange = (panel: string, value: string) => {
		const newSelectedAnswers = {...selectedAnswers, [panel]: parseInt(value)};
		setSelectedAnswers(newSelectedAnswers);
		localStorage.setItem('userAnswers', JSON.stringify({day: today, answers: newSelectedAnswers}));
		
		if (panel === 'panel1' || panel === 'panel2') {
			console.log(dialogShownFor);
			if (!dialogShownFor.has(panel)) {
				setDialogShownFor(new Set(dialogShownFor).add(panel));
				setSelectedPanel(panel);
				setOpenDialog(true);
			}
		}
		
		const newCorrectnessArray = todayQuestions.map((q, index) => {
			const panelId = `panel${index + 1}`;
			return newSelectedAnswers[panelId] === q.correctAnswer ? 1 : 0;
		});
		setCorrectnessArray(newCorrectnessArray);
		
		if (panel === `panel${todayQuestions.length}`) {
			setShowSubmit(true);
		}
	};
	
	useEffect(() => {
		// setShowSubmit(Object.keys(selectedAnswers).length === todayQuestions.length);
	}, [selectedAnswers, todayQuestions]);
	
	const handleSubmit = () => {
		setAnswers(selectedAnswers);
		setCorrectAnswers(correctnessArray);
		setShowSubmit(false);
		setMission(1);
	};
	const handleCloseDialog = () => setOpenDialog(false);
	
	return (
		<>
			<Dialog
				open={openDialog}
				onClose={handleCloseDialog}
				PaperProps={{
					sx: {
						padding: '10px'
						// width: '90%', // Adjust width dynamically
						// textAlign: 'center'
					}
				}}
			>
				<DialogTitle className={'text-center text-green-700'}>ادامه بده دوست عزیز</DialogTitle>
				<DialogContent>
					{selectedPanel === 'panel1' ? (
						<Typography>
							<div>
								فقط دو قدم تا جایزه داری!
							</div>
							<div>
								حالا آماده شو برای سوال بعدی!
							</div>
						</Typography>
					) : (
						<Typography>
							<div>ممنون که تا این لحظه همراه ما بودی</div>
							<div>داری به جایزه نزدیک میشی!</div>
						</Typography>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setOpenDialog(false)}>ادامه می دم</Button>
				</DialogActions>
			</Dialog>
			{
				countdown === null && currentMinutes < 45 && (
					<div className="text-center text-white font-bold py-2">
						لطفا منتظر بمانید
					</div>
				)
			}
			{todayQuestions.length > 0 && countdown !== null && mission == 0 && (
				<div className="text-center text-white font-bold py-2">
					زمان باقی مانده: {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, '0')}
				</div>
			)}
			{mission === 0 && (
				<div className="w-full mx-auto pb-20">
					{todayQuestions.length > 0 &&
						todayQuestions.map((q, index) => {
							const panelId = `panel${index + 1}`;
							return (
								<Accordion
									key={panelId}
									expanded={expanded === panelId}
									onChange={(event, isExpanded) => {
										if (!isExpanded) return; // Prevent manual collapsing
										setExpanded(panelId);
									}}
									disabled={disabledState[panelId as keyof typeof disabledState]}
									className={`w-full mb-2 overflow-hidden transition-all rounded-2xl ${
										disabledState[panelId as keyof typeof disabledState]
											? 'opacity-60 bg-gray-200 cursor-not-allowed'
											: 'bg-white'
									}`}
									sx={{
										'&:before': {display: 'none'},
										'&.MuiAccordion-root': {margin: 0, border: 'none', boxShadow: 'none'}
									}}
								>
									<AccordionSummary
										expandIcon={
											<ExpandMoreIcon
												sx={{
													color: expanded === panelId ? 'white' : '#ccc',
													transition: 'color 0.3s ease'
												}}
											/>
										}
										aria-controls={`${panelId}-content`}
										id={`${panelId}-header`}
										className="px-4 flex justify-between items-center"
										sx={{
											minHeight: '48px !important',
											backgroundColor: expanded === panelId ? 'rgb(0,64,56)' : 'rgb(0,64,56)',
											transition: 'background-color 0.3s ease',
											'&.Mui-expanded': {
												minHeight: '48px !important',
												margin: '0 !important'
											}
										}}
									>
										{/* Display question number */}
										<Typography component="span" className="font-semibold text-white w-16">
											{`سوال: ${index + 1}`}
										</Typography>
										
										{/* Display selected answer if available */}
										{selectedAnswers[panelId] !== undefined && (
											<Typography component="span"
											            className="font-semibold text-yellow-300 text-sm ml-4 text-center content-center">
												{q.answers[selectedAnswers[panelId] as number]}
											</Typography>
										)}
									</AccordionSummary>
									<AccordionDetails
										className="border-t border-gray-200"
										sx={{
											border: 'none',
											boxShadow: 'none',
											padding: '8px 16px',
											backgroundColor: 'rgba(0,64,56,0.63)'
										}}
									>
										<div className="flex flex-col gap-y-2">
											<Typography component="span" className="text-white font-bold">
												{q.question}
											</Typography>
											<FormControl component="fieldset">
												<RadioGroup
													name={`question-${index}`}
													className={'flex flex-col justify-start bg-re'}
													value={selectedAnswers[panelId] ?? ''}
													onChange={(e) => handleAnswerChange(panelId, e.target.value)}
												>
													{q.answers.map((answer, i) => (
														<FormControlLabel
															key={i}
															value={i}
															control={
																<Radio sx={{
																	transform: 'scale(0.8)',
																	color: '#004038',
																	'&.Mui-checked': {
																		color: '#fff'
																	}
																}}/>
															}
															label={<Typography className="text-sm">{answer}</Typography>}
															className="pr-2 rounded-md transition flex flex-row text-white h-8"
														/>
													))}
												</RadioGroup>
											</FormControl>
										</div>
									</AccordionDetails>
								</Accordion>
							);
						})}
					
					{todayQuestions.length > 0 && showSubmit && (
						<div className="w-full flex flex-row justify-center mt-10 text-center">
							<img src={answersImg} alt="start" className={'w-fit h-8 cursor-pointer'} onClick={handleSubmit}/>
						</div>
					)}
				</div>
			)}
			
			{mission === 1 && <Phone/>}
			{mission === 2 && <MissionCompleted/>}
		</>
	);
};

export default SpecialComponent;
